"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildColony = void 0;
const SelectColony_1 = require("../inputs/SelectColony");
const ColonyName_1 = require("../colonies/ColonyName");
const DeferredAction_1 = require("./DeferredAction");
const PartyHooks_1 = require("../turmoil/parties/PartyHooks");
const PartyName_1 = require("../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../turmoil/RedsPolicy");
const CardName_1 = require("../CardName");
class BuildColony {
    constructor(player, allowDuplicate = false, title = 'Select where to build a colony', openColonies) {
        this.player = player;
        this.allowDuplicate = allowDuplicate;
        this.title = title;
        this.openColonies = openColonies;
        this.priority = DeferredAction_1.Priority.BUILD_COLONY;
    }
    execute() {
        if (this.openColonies === undefined) {
            if (this.allowDuplicate) {
                this.openColonies = this.player.game.colonies.filter((colony) => colony.isActive && colony.colonies.length < 3);
            }
            else {
                this.openColonies = this.player.game.colonies.filter((colony) => colony.isActive && colony.colonies.includes(this.player.id) === false);
            }
            if (this.player.game.gameOptions.equalOpportunityVariant === false) {
                this.openColonies = this.openColonies.filter((colony) => colony.colonies.length < 3);
            }
        }
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(this.player, PartyName_1.PartyName.REDS);
        if (redsAreRuling) {
            const bonusMegaCredits = this.player.cardIsInEffect(CardName_1.CardName.NAOMI) ? 3 : 0;
            const canAffordToBuildOnEuropaColony = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(this.player, this.player.game, new RedsPolicy_1.ActionDetails({ oceansToPlace: 1, bonusMegaCredits: bonusMegaCredits }));
            if (canAffordToBuildOnEuropaColony.canAfford === false) {
                this.openColonies = this.openColonies.filter((c) => c.name !== ColonyName_1.ColonyName.EUROPA);
            }
            else {
                this.player.howToAffordReds = canAffordToBuildOnEuropaColony;
            }
            const canAffordToBuildOnVenusColony = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(this.player, this.player.game, new RedsPolicy_1.ActionDetails({ venusIncrease: 1, bonusMegaCredits: bonusMegaCredits }));
            if (canAffordToBuildOnVenusColony.canAfford === false)
                this.openColonies = this.openColonies.filter((c) => c.name !== ColonyName_1.ColonyName.VENUS);
            const canAffordToBuildOnIapetusColony = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(this.player, this.player.game, new RedsPolicy_1.ActionDetails({ TRIncrease: 1, bonusMegaCredits: bonusMegaCredits }));
            if (canAffordToBuildOnIapetusColony.canAfford === false)
                this.openColonies = this.openColonies.filter((c) => c.name !== ColonyName_1.ColonyName.IAPETUS);
        }
        if (this.openColonies.length === 0)
            return undefined;
        const openColonies = this.openColonies;
        const coloniesModel = this.player.game.getColoniesModel(openColonies);
        return new SelectColony_1.SelectColony(this.title, 'Build', coloniesModel, (colonyName) => {
            openColonies.forEach((colony) => {
                if (colony.name === colonyName) {
                    colony.addColony(this.player);
                }
                return undefined;
            });
            return undefined;
        });
    }
}
exports.BuildColony = BuildColony;
//# sourceMappingURL=BuildColony.js.map